import { articles, staticRoutes } from '../content/site'
import type { Article } from '../types'

export type RouteName = 'home' | 'services' | 'contact' | 'insights' | 'article' | 'not-found'

export interface ResolvedRoute {
  name: RouteName
  path: string
  article?: Article
}

export function normalizePath(pathname: string): string {
  const withoutQuery = pathname.split(/[?#]/, 1)[0] || '/'
  if (withoutQuery === '/') return '/'
  return `/${withoutQuery.replace(/^\/+|\/+$/g, '')}/`
}

export function resolveRoute(pathname: string): ResolvedRoute {
  const path = normalizePath(pathname)

  if (path === '/') return { name: 'home', path }
  if (path === '/services/') return { name: 'services', path }
  if (path === '/contact/') return { name: 'contact', path }
  if (path === '/insights/') return { name: 'insights', path }

  const article = articles.find((item) => `/${item.slug}/` === path)
  if (article) return { name: 'article', path, article }

  return { name: 'not-found', path }
}

export { staticRoutes }
